import React from 'react';
import '../styles/ThemeSelector.css';

const ThemeSelector = ({ currentTheme, onThemeChange }) => {
  const themes = [
    { id: 'light', name: 'Light', brand: 'Default Light' },
    { id: 'dark', name: 'Dark', brand: 'Default Dark' },
    { id: 'hclBlue', name: 'HCL Blue', brand: 'HCL Technologies' },
    { id: 'unica', name: 'Unica', brand: 'Unica Platform' },
    { id: 'maxAI', name: 'MaxAI', brand: 'MaxAI Solutions' }
  ];

  return (
    <div className="theme-palette">
      <div className="theme-options">
        {themes.map(theme => (
          <div 
            key={theme.id}
            className={`theme-option ${theme.id} ${currentTheme === theme.id ? 'active' : ''}`}
            onClick={() => onThemeChange(theme.id)}
          >
            {currentTheme === theme.id && (
              <span className="material-icons" style={{ fontSize: '16px', color: theme.id === 'light' ? '#333' : '#fff' }}>
                check
              </span>
            )}
            <div className="theme-tooltip">
              {theme.brand}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;